import { render } from "./rateView.vue?vue&type=template&id=5c319a78&scoped=true"
import script from "./rateView.vue?vue&type=script&lang=js"
export * from "./rateView.vue?vue&type=script&lang=js"

import "./rateView.vue?vue&type=style&index=0&id=5c319a78&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c319a78"]])

export default __exports__